export const FETCH_AGGREGATE_FILTERS = 'FETCH_AGGREGATE_FILTERS';
export const FETCH_AGGREGATE_FILTERS_SUCCESS = 'FETCH_AGGREGATE_FILTERS_SUCCESS';
export const FETCH_AGGREGATE_FILTERS_FAIL = 'FETCH_AGGREGATE_FILTERS_FAIL';
export const CLEAR_AGGREGATE_FILTERS = 'CLEAR_AGGREGATE_FILTERS';

export function fetchAggregateFilters(flatFilters) {
    return {
        type: FETCH_AGGREGATE_FILTERS,
        payload: { flatFilters },
    };
}

export function fetchAggregateFiltersSuccess(options) {
    return {
        type: FETCH_AGGREGATE_FILTERS_SUCCESS,
        payload: options,
    };
}

export function fetchAggregateFiltersFail(error) {
    return {
        type: FETCH_AGGREGATE_FILTERS_FAIL,
        payload: error,
    };
}

export function clearAggregateFilters() {
    return {
        type: CLEAR_AGGREGATE_FILTERS,
    };
}
